import { createApiSlice } from "@common";
import {
  CRUD_BASIC,
  GET_BASIC_BY_INTEGRATION,
  GET_BASIC_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addBasicIntegration",
    method: "post",
    url: CRUD_BASIC,
    stateKey: "message",
  },
  {
    name: "getBasicByIntegration",
    method: "get",
    url: GET_BASIC_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "updateBasicIntegration",
    method: "put",
    url: CRUD_BASIC,
    stateKey: "message",
  },
  {
    name: "deleteBasicIntegration",
    method: "delete",
    url: CRUD_BASIC,
    stateKey: "message",
  },
  {
    name: "updateBasicIntegrationStatus",
    method: "patch",
    url: GET_BASIC_STATUS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "basic",
  apiConfig,
  customReducers,
);
const basicSlice = slice;
// Export the slice's reducer
export default basicSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addBasicIntegration,
  getBasicByIntegration,
  updateBasicIntegration,
  deleteBasicIntegration,
  updateBasicIntegrationStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
